// URL base de la API
export const API_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000/api';

export { legalConfig } from './legal';

// Configuración base de la aplicación
export const config = {
  // Configuración de la API
  api: {
    baseUrl: API_URL,
    timeout: 30000, // 30 segundos
  },
  
  // Configuración de autenticación
  auth: {
    clientId: process.env.NEXT_PUBLIC_AUTH_CLIENT_ID || '',
    authority: process.env.NEXT_PUBLIC_AUTH_AUTHORITY || '',
    redirectUri: process.env.NEXT_PUBLIC_AUTH_REDIRECT_URI || 'http://localhost:3000',
  },
  
  // Configuración de características
  features: {
    enableEmail: true,
    enableNotifications: true,
  },
};

export default config;
